import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-observation-chips',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatIconModule],
  template: `
    <div class="chips-row">
      <div class="chip chip--cyan">
        <mat-icon class="chip__icon">water_drop</mat-icon>
        <span class="chip__label" i18n="@@details.observationChips.swallowCount">嚥下回数</span>
        <span class="chip__value" i18n="@@details.observationChips.swallowValue">{{ swallowCount() }} 回</span>
      </div>
      <div class="chip chip--orange">
        <mat-icon class="chip__icon">air</mat-icon>
        <span class="chip__label" i18n="@@details.observationChips.coughCount">せき・むせ回数</span>
        <span class="chip__value" i18n="@@details.observationChips.coughValue">{{ coughCount() }} 回</span>
      </div>
      <div class="chip chip--purple">
        <mat-icon class="chip__icon">schedule</mat-icon>
        <span class="chip__label" i18n="@@details.observationChips.duration">計測時間</span>
        <span class="chip__value">{{ formattedDuration() }}</span>
      </div>
    </div>
  `,
  styles: [`
    .chips-row {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: var(--space-md);
    }
    .chip {
      display: flex;
      align-items: center;
      gap: var(--space-sm);
      padding: var(--space-sm) var(--space-md);
      border-radius: var(--radius-full);
      white-space: nowrap;
    }
    .chip--cyan { background: #00ccff10; }
    .chip--cyan .chip__icon, .chip--cyan .chip__value { color: #00ccff; }
    .chip--orange { background: #ff6b3510; }
    .chip--orange .chip__icon, .chip--orange .chip__value { color: #ff6b35; }
    .chip--purple { background: #7c4dff10; }
    .chip--purple .chip__icon, .chip--purple .chip__value { color: #7c4dff; }
    .chip__icon { font-size: 16px; width: 16px; height: 16px; }
    .chip__label { font-size: var(--font-size-label-sm); color: var(--gokuri-text-secondary); white-space: nowrap; }
    .chip__value { font-size: var(--font-size-body-md); font-weight: 700; white-space: nowrap; }

    @media (max-width: 767px) {
      .chips-row {
        gap: 6px;
      }
      .chip {
        gap: 6px;
        padding: 4px 8px;
      }
      .chip__icon {
        font-size: 14px;
        width: 14px;
        height: 14px;
      }
      .chip__label {
        font-size: 10px;
      }
      .chip__value {
        font-size: var(--font-size-body-sm);
      }
    }
  `],
})
export class ObservationChipsComponent {
  readonly swallowCount = input.required<number>();
  readonly coughCount = input.required<number>();
  readonly durationSec = input.required<number>();

  protected readonly formattedDuration = computed(() => {
    const sec = this.durationSec();
    const mins = Math.floor(sec / 60);
    const secs = Math.floor(sec % 60);
    return $localize`:@@details.observationChips.durationFormat:${mins}分${secs.toString().padStart(2, '0')}秒`;
  });
}
